(function () {
  var root = document.getElementById('RiAddedPanel');
  if (!root) return;

  var itemsEl = root.querySelector('[data-ri-added-items]');
  var totalEl = root.querySelector('[data-ri-added-total]');
  var noteEl = root.querySelector('[data-ri-note]');
  var goalEl = root.querySelector('[data-ri-added-goal]');
  var extrasEl = root.querySelector('[data-ri-added-extras]');
  var extrasList = root.querySelector('[data-ri-added-extras-list]');
  var panel = root.querySelector('.ri-added__panel');
  var desktop = window.matchMedia('(min-width: 990px)');
  var token = 0;

  var ACCESSORIES = {
    n64: 'n64-accessories',
    nes: 'nes-accessories',
    snes: 'snes-accessories',
    gamecube: 'gamecube-accessories',
    wii: 'wii-accessories',
    wiiu: 'wii-u-accessories',
    switch: 'switch-accessories',
    gb: 'gameboy-accessories',
    gbc: 'gameboy-accessories',
    gba: 'gameboy-advance-accessories',
    nds: 'ds-accessories',
    '3ds': '3ds-accessories',
    ps1: 'ps1-accessories',
    ps2: 'ps2-accessories',
    ps3: 'ps3-accessories',
    ps4: 'ps4-accessories',
    ps5: 'ps5-accessories',
    psp: 'psp-accessories',
    vita: 'ps-vita-accessories',
    genesis: 'genesis-accessories',
    saturn: 'saturn-accessories',
    dreamcast: 'dreamcast-collection',
    xbox: 'original-xbox-accessories',
    xbox360: 'xbox-361',
    xboxone: 'xbox-one-accessories',
    xboxseries: 'xbox-series-x-accessories'
  };

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function moneyHtml(cents) {
    var amount = Number(cents);
    if (!isFinite(amount)) return '';
    var dollars = Math.floor(amount / 100);
    var rest = String(Math.abs(amount % 100));
    if (rest.length < 2) rest = '0' + rest;
    return (
      '<span class="ri-money">' +
        '<span class="ri-money__symbol" aria-hidden="true">$</span>' +
        '<span class="ri-money__dollars">' + dollars + '</span>' +
        '<span class="ri-money__cents" aria-hidden="true">' + rest + '</span>' +
        '<span class="visually-hidden">$' + dollars + '.' + rest + '</span>' +
      '</span>'
    );
  }

  function familyFrom(value) {
    var s = String(value || '').toLowerCase();
    if (!s) return '';
    if (/ps\s*vita|\bvita\b/.test(s)) return 'vita';
    if (/\bpsp\b/.test(s)) return 'psp';
    if (/playstation\s*5|\bps5\b/.test(s)) return 'ps5';
    if (/playstation\s*4|\bps4\b/.test(s)) return 'ps4';
    if (/playstation\s*3|\bps3\b/.test(s)) return 'ps3';
    if (/playstation\s*2|\bps2\b/.test(s)) return 'ps2';
    if (/playstation|\bps1\b|\bpsx\b/.test(s)) return 'ps1';
    if (/nintendo\s*64|\bn64\b/.test(s)) return 'n64';
    if (/game\s*boy\s*advance|\bgba\b/.test(s)) return 'gba';
    if (/game\s*boy\s*color|\bgbc\b/.test(s)) return 'gbc';
    if (/game\s*boy|\bgameboy\b/.test(s)) return 'gb';
    if (/super\s*(nintendo|nes)|\bsnes\b/.test(s)) return 'snes';
    if (/\bnes\b|nintendo entertainment/.test(s)) return 'nes';
    if (/gamecube|game\s*cube/.test(s)) return 'gamecube';
    if (/xbox\s*series/.test(s)) return 'xboxseries';
    if (/xbox\s*one/.test(s)) return 'xboxone';
    if (/xbox\s*360/.test(s)) return 'xbox360';
    if (/xbox/.test(s)) return 'xbox';
    if (/dreamcast/.test(s)) return 'dreamcast';
    if (/genesis|mega\s*drive/.test(s)) return 'genesis';
    if (/saturn/.test(s)) return 'saturn';
    if (/wii\s*u/.test(s)) return 'wiiu';
    if (/\bwii\b/.test(s)) return 'wii';
    if (/3ds/.test(s)) return '3ds';
    if (/nintendo\s*ds|\bds\b/.test(s)) return 'nds';
    if (/switch/.test(s)) return 'switch';
    return '';
  }

  function imageUrl(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || image.url || '';
  }

  function closeSheets() {
    root.querySelectorAll('[data-ri-sheet]').forEach(function (sheet) {
      sheet.hidden = true;
    });
  }

  function clearSheetSize() {
    var panel = root.querySelector('.ri-added__panel');
    root.style.removeProperty('--ri-added-top');
    if (!panel) return;
    panel.style.top = '';
    panel.style.height = '';
    panel.style.left = '';
    panel.style.right = '';
    panel.style.width = '';
    panel.style.bottom = '';
  }

  function fitSheet() {
    var panel = root.querySelector('.ri-added__panel');
    if (!panel || !root.classList.contains('is-open') || desktop.matches) {
      clearSheetSize();
      document.documentElement.classList.remove('ri-sheet-open');
      return;
    }
    var vv = window.visualViewport;
    var top = vv ? Math.max(0, vv.offsetTop) : 0;
    var height = vv ? vv.height : window.innerHeight;
    /* Opened from the header cart: the blue header stays visible, with an X in the cart's place. */
    if (root.classList.contains('is-from-header')) {
      var header = document.querySelector('.section-header');
      var edge = header ? Math.round(header.getBoundingClientRect().bottom) : 0;
      if (edge > top && edge < height) {
        height -= edge - top;
        top = edge;
      }
    }
    root.style.setProperty('--ri-added-top', top + 'px');
    panel.style.top = top + 'px';
    panel.style.left = '0';
    panel.style.right = '0';
    panel.style.width = '100%';
    panel.style.height = height + 'px';
    panel.style.bottom = 'auto';
    document.documentElement.classList.add('ri-sheet-open');
    document.documentElement.style.setProperty('--ri-sticky-atc-pad', '0px');
  }

  function closePanel() {
    closeSheets();
    root.classList.remove('is-open', 'is-from-header');
    document.documentElement.classList.remove('ri-cart-open');
    root.hidden = true;
    clearSheetSize();
    document.documentElement.classList.remove('ri-sheet-open');
    if (root._riLocked && window.RIScrollLock) {
      window.RIScrollLock.unlock();
      root._riLocked = false;
    }
    var opener = root._riOpener;
    root._riOpener = null;
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(opener && opener.isConnected ? opener : null);
    }
  }

  function openShell() {
    root.hidden = false;
    root.classList.add('is-open');
    fitSheet();
    if (!desktop.matches && !root._riLocked && window.RIScrollLock) {
      window.RIScrollLock.lock();
      root._riLocked = true;
    }
    var panel = root.querySelector('.ri-added__panel');
    var active = document.activeElement;
    if (active && active !== document.body && !root.contains(active)) root._riOpener = active;
    if (typeof trapFocus === 'function' && panel) trapFocus(panel, root.querySelector('.ri-added__x'));
    var closeBtn = root.querySelector('.ri-added__x');
    if (closeBtn) closeBtn.focus();
  }

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-ri-added-close]')) closePanel();
    var openSheet = event.target.closest('[data-ri-sheet-open]');
    if (openSheet) {
      closeSheets();
      var name = openSheet.getAttribute('data-ri-sheet-open');
      var sheet = root.querySelector('[data-ri-sheet="' + name + '"]');
      if (sheet) sheet.hidden = false;
    }
    if (event.target.closest('[data-ri-sheet-close]') || event.target.matches('[data-ri-sheet]')) closeSheets();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !root.hidden) closePanel();
  });

  function isProtection(line) {
    var props = line.properties || {};
    var title = String(line.product_title || line.title || '').toLowerCase();
    return title.indexOf('shipping protection') !== -1;
  }

  function contentLine(line) {
    var options = line.options_with_values || [];
    var bits = options.filter(function (option) {
      return option && option.value && option.value !== 'Default Title';
    }).map(function (option) {
      return escapeHtml(option.name) + ': ' + escapeHtml(option.value);
    });
    if (!bits.length && line.variant_title && line.variant_title !== 'Default Title') {
      bits.push(escapeHtml(line.variant_title));
    }
    return bits.join('<br>');
  }

  function canAdd(line) {
    if (!line.inventory_management) return true;
    if (line.inventory_policy === 'continue') return true;
    return Number(line.quantity) < Number(line.inventory_quantity);
  }

  function pillMod(platform) {
    var s = String(platform || '').toLowerCase().trim();
    if (!s) return 'default';
    if (s.indexOf('64') !== -1) return 'n64';
    if (s.indexOf('color') !== -1 || s.indexOf('gbc') !== -1) return 'gbc';
    if (s.indexOf('advance') !== -1 || s.indexOf('gba') !== -1) return 'gba';
    if (s.indexOf('gamecube') !== -1 || s.indexOf('game cube') !== -1) return 'gamecube';
    if (s.indexOf('3ds') !== -1) return 'nintendo';
    if (s.indexOf('ds') !== -1) return 'ds';
    if (s.indexOf('wii u') !== -1) return 'wiiu';
    if (s.indexOf('wii') !== -1) return 'wii';
    if (s.indexOf('ps5') !== -1 || s.indexOf('playstation 5') !== -1) return 'ps5';
    if (s.indexOf('ps4') !== -1 || s.indexOf('playstation 4') !== -1 || s.indexOf('psp') !== -1 || s.indexOf('vita') !== -1) return 'ps4';
    if (s.indexOf('ps3') !== -1 || s.indexOf('playstation 3') !== -1) return 'ps3';
    if (s.indexOf('ps2') !== -1 || s.indexOf('playstation 2') !== -1) return 'ps2';
    if (s === 'playstation' || s === 'ps1' || s === 'psx') return 'ps1';
    if (s.indexOf('xbox') !== -1) return 'xbox';
    if (s.indexOf('dreamcast') !== -1) return 'dreamcast';
    if (s.indexOf('sega') !== -1 || s.indexOf('genesis') !== -1 || s.indexOf('saturn') !== -1) return 'sega';
    if (s.indexOf('atari') !== -1) return 'atari';
    if (s.indexOf('snes') !== -1 || s.indexOf('super nintendo') !== -1 || s.indexOf('super famicom') !== -1 || s.indexOf('super nes') !== -1) return 'snes';
    if (s.indexOf('nintendo') !== -1 || s.indexOf('switch') !== -1 || s.indexOf('nes') !== -1 || s.indexOf('famicom') !== -1 || s.indexOf('mario') !== -1) return 'nintendo';
    return 'default';
  }

  function lineMarkup(line) {
    var title = line.product_title || line.title || 'Item';
    var href = line.url || '#';
    var photo = imageUrl(line.image) || imageUrl(line.featured_image);
    var platform = String(line.product_type || '').trim();
    var pill = platform
      ? '<span class="ri-platform-pill ri-platform-pill--' + pillMod(platform) + '">' + escapeHtml(platform) + '</span>'
      : '';
    var key = escapeHtml(line.key);
    var qty = Number(line.quantity) || 0;
    /* The name drops its " - Platform" ending when the pill under it says the same (owner, 2026-10-23), as the
       shelves and search do: Wii Play - Wii reads Wii Play, with the WII pill right under it. */
    var shownTitle = title;
    if (platform) {
      var titleParts = String(title).split(/\s+[-–—]\s+/);
      if (titleParts.length > 1 && titleParts[titleParts.length - 1].trim().toLowerCase() === platform.toLowerCase()) {
        shownTitle = titleParts.slice(0, -1).join(' - ');
      }
    }
    /* Discounts (owner, 2026-10-23: Buy 2 Get 1 never showed in Your Cart). The free game's final price is 0, and
       `final_price || price` read that 0 as missing and showed the full price. A discounted line now shows the old
       price struck through over the new one, and each discount it counts toward (as the cart page does). */
    var unit = Number(line.price) || 0;
    var now = line.final_price != null && isFinite(Number(line.final_price)) ? Number(line.final_price) : unit;
    var priceHtml = now < unit
      ? '<s class="ri-added__was"><span class="visually-hidden">Was </span>' + moneyHtml(unit) + '</s>' +
        '<span class="ri-added__now"><span class="visually-hidden">Now </span>' + moneyHtml(now) + '</span>'
      : moneyHtml(now);
    var dealTitles = [];
    (line.line_level_discount_allocations || []).forEach(function (allocation) {
      var title = allocation && allocation.discount_application && allocation.discount_application.title;
      if (title && dealTitles.indexOf(title) === -1) dealTitles.push(title);
    });
    if (!dealTitles.length) {
      (line.discounts || []).forEach(function (discount) {
        if (discount && discount.title && dealTitles.indexOf(discount.title) === -1) dealTitles.push(discount.title);
      });
    }
    var deals = dealTitles.map(function (title) {
      return '<span class="ri-added__deal">' + escapeHtml(title) + '</span>';
    }).join('');
    return (
      '<div class="ri-added__line">' +
        '<a class="ri-added__photo" href="' + escapeHtml(href) + '">' +
          (photo ? '<img src="' + escapeHtml(photo) + '" alt="" width="120" height="120">' : '') +
        '</a>' +
        '<div class="ri-added__copy">' +
          '<div class="ri-added__topline">' +
            '<div class="ri-added__name-block">' +
              '<p class="ri-added__name"><a href="' + escapeHtml(href) + '">' + escapeHtml(shownTitle) + '</a></p>' +
              (pill ? '<div class="ri-added__meta">' + pill + '</div>' : '') +
            '</div>' +
            '<div class="ri-added__price' + (now < unit ? ' ri-added__price--deal' : '') + '">' + priceHtml + '</div>' +
          '</div>' +
          /* Minus, number, plus, then Remove in words at every width (owner, 2026-10-23: the phone trash is gone). */
          '<div class="ri-added__qty">' +
            '<button type="button" class="ri-added__step" data-ri-qty="' + key + '" data-ri-qty-set="' + (qty - 1) + '" aria-label="' + (qty <= 1 ? 'Remove' : 'Decrease') + '">−</button>' +
            '<span class="ri-added__qty-num">' + qty + '</span>' +
            '<button type="button" class="ri-added__step" data-ri-qty="' + key + '" data-ri-qty-set="' + (qty + 1) + '"' + (canAdd(line) ? '' : ' disabled') + ' aria-label="Increase">+</button>' +
            '<button type="button" class="ri-added__remove" data-ri-qty="' + key + '" data-ri-qty-set="0" aria-label="Remove ' + escapeHtml(shownTitle) + '">Remove</button>' +
          '</div>' +
          (contentLine(line) ? '<p class="ri-added__content">' + contentLine(line) + '</p>' : '') +
          (deals ? '<p class="ri-added__deals">' + deals + '</p>' : '') +
        '</div>' +
      '</div>'
    );
  }

  function moneyWithCurrency(cents, currency) {
    var amount = Number(cents);
    if (!isFinite(amount)) return '';
    var dollars = Math.floor(Math.abs(amount) / 100);
    var rest = String(Math.abs(amount) % 100);
    if (rest.length < 2) rest = '0' + rest;
    var sign = amount < 0 ? '-' : '';
    return sign + '$' + dollars + '.' + rest + (currency ? ' ' + currency : '');
  }

  function paintSummary(cart) {
    paintHeaderTotal(cart);
    if (window.RIProtection) window.RIProtection.onCart(cart);
    var lines = (cart.items || []).filter(function (line) { return !isProtection(line); });
    if (totalEl) totalEl.textContent = moneyWithCurrency(cart.total_price, cart.currency);
    if (noteEl && document.activeElement !== noteEl) noteEl.value = cart.note || '';
    if (!lines.length) {
      itemsEl.innerHTML = '<p class="ri-added__empty">Your cart is empty</p>';
      return;
    }
    itemsEl.innerHTML = lines.map(lineMarkup).join('');
  }

  function paintGoal(count) {
    if (!goalEl) return;
    if (!count) {
      goalEl.hidden = true;
      goalEl.textContent = '';
      return;
    }
    var shown = Math.min(count, 2);
    goalEl.hidden = false;
    goalEl.textContent = 'Games under $15: buy 2, get 1 free. ' + shown + ' of 2';
  }

  function productIsGame(product) {
    var tags = (product && product.tags) || [];
    if (typeof tags === 'string') tags = tags.split(',');
    return tags.some(function (tag) {
      return String(tag).trim().toLowerCase() === 'game';
    });
  }

  function loadGoal(cart) {
    if (!goalEl) return Promise.resolve();
    var cheap = (cart.items || []).filter(function (item) {
      return Number(item.price) < 1500 && item.handle;
    });
    if (!cheap.length) {
      paintGoal(0);
      return Promise.resolve();
    }
    return Promise.all(cheap.map(function (item) {
      return fetch(shopRoot() + 'products/' + item.handle + '.js', { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (product) {
          return product && productIsGame(product) ? Number(item.quantity) || 0 : 0;
        })
        .catch(function () { return 0; });
    })).then(function (counts) {
      var total = counts.reduce(function (sum, n) { return sum + n; }, 0);
      paintGoal(total);
    });
  }

  function extraScore(title) {
    var s = String(title || '').toLowerCase();
    if (/controller/.test(s)) return 3;
    if (/cable|av |hdmi|memory/.test(s)) return 2;
    return 1;
  }

  function paintExtras(products, skipHandle) {
    var picks = (products || [])
      .filter(function (product) {
        return product && product.handle !== skipHandle && product.variants && product.variants.some(function (variant) {
          return variant.available;
        });
      })
      .sort(function (a, b) { return extraScore(b.title) - extraScore(a.title); })
      .slice(0, 2);
    if (!picks.length) {
      extrasEl.hidden = true;
      extrasList.innerHTML = '';
      return;
    }
    extrasList.innerHTML = picks.map(function (product) {
      var variant = product.variants.filter(function (item) { return item.available; })[0];
      var photo = (product.images && product.images[0]) || '';
      if (photo && typeof photo !== 'string') photo = photo.src || '';
      return (
        '<div class="ri-added__extra">' +
          (photo ? '<img src="' + escapeHtml(photo) + '" alt="" width="72" height="72">' : '<span></span>') +
          '<p class="ri-added__extra-name">' + escapeHtml(product.title) + '</p>' +
          '<button type="button" class="ri-added__extra-add" data-ri-added-extra="' + variant.id + '">Add</button>' +
        '</div>'
      );
    }).join('');
    extrasEl.hidden = false;
  }

  function loadExtras(line) {
    if (!extrasEl || !extrasList) return Promise.resolve();
    var family = familyFrom(line.product_type) || familyFrom(line.product_title) || familyFrom(line.title);
    var handle = ACCESSORIES[family];
    if (!handle) {
      extrasEl.hidden = true;
      return Promise.resolve();
    }
    return fetch(shopRoot() + 'collections/' + handle + '/products.json?limit=12', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : { products: [] }; })
      .then(function (data) { paintExtras(data.products, line.handle); })
      .catch(function () { extrasEl.hidden = true; });
  }

  function cartUrl(kind) {
    var routes = window.routes || {};
    if (kind === 'change') return routes.cart_change_url || '/cart/change';
    if (kind === 'update') return routes.cart_update_url || '/cart/update';
    return ((routes.cart_url) || '/cart') + '.js';
  }

  function postCart(kind, body) {
    return fetch(cartUrl(kind), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (response) { return response.json(); });
  }

  function refreshCartChrome(cart) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ri-added-panel', cartData: cart });
    }
  }

  /* Header total changes the moment the cart does, not after the page section reloads. */
  function paintHeaderTotal(cart) {
    var totalSlot = document.querySelector('#cart-icon-bubble .ri-header__cart-total');
    if (!totalSlot || !cart || cart.status) return;
    var label = document.querySelector('#cart-icon-bubble .ri-header__icon-label');
    var empty = !cart.item_count;
    totalSlot.hidden = empty;
    if (label) label.hidden = !empty;
    if (!empty) totalSlot.innerHTML = moneyHtml(cart.total_price);
  }

  /* Shopify answers an over-stock change with { errors: "..." } and no items. That is not a cart. */
  function isCart(cart) {
    return !!cart && !cart.status && !cart.errors && Array.isArray(cart.items);
  }

  function showStockNote(text) {
    var note = root.querySelector('.ri-added__stock-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'ri-added__stock-note';
      note.setAttribute('role', 'status');
      itemsEl.parentNode.insertBefore(note, itemsEl);
    }
    note.textContent = text || 'That is all we have in stock.';
    note.hidden = false;
    window.clearTimeout(note._riTimer);
    note._riTimer = window.setTimeout(function () {
      note.hidden = true;
    }, 4000);
  }

  function applyCart(cart) {
    if (!isCart(cart)) return;
    paintHeaderTotal(cart);
    paintSummary(cart);
    refreshCartChrome(cart);
    loadGoal(cart);
  }

  if (extrasList) extrasList.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ri-added-extra]');
    if (!button || button.disabled) return;
    button.disabled = true;
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(button.getAttribute('data-ri-added-extra')), quantity: 1 })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data && data.status) throw new Error('add');
        button.textContent = 'Added';
        return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
      })
      .then(function (response) { return response && response.json ? response.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        applyCart(cart);
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'Add';
      });
  });

  function showLine(line) {
    var current = ++token;
    if (goalEl) goalEl.hidden = true;
    if (extrasEl) extrasEl.hidden = true;
    openShell();
    fetch(cartUrl('get'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (current !== token) return;
        paintSummary(cart);
        return Promise.all([loadGoal(cart), loadExtras(line)]);
      })
      .catch(function () {
        if (current === token) paintGoal(0);
      });
  }

  /* Shipping protection switch: the app changes the cart on its own, so read the cart again afterwards. */
  window.RIAddedPanelRefresh = function () {
    return fetch(cartUrl('get'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(applyCart)
      .catch(function () {});
  };

  /* Header cart icon: a quick look at the cart, closed again by the same spot. */
  var cartSheetWidth = window.matchMedia('(max-width: 989px)');

  /* One layer at a time: opening the menu or the search puts the cart away, and the cart does the same to the menu. */
  function closeMenuForCart() {
    document.querySelectorAll('header-drawer details[open] > summary, menu-drawer details[open] > summary').forEach(function (summary) {
      summary.click();
    });
    if (document.documentElement.classList.contains('ri-search-open')) {
      document.querySelectorAll('predictive-search').forEach(function (el) {
        if (typeof el.close === 'function') el.close();
      });
    }
  }

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details || !details.matches || !details.matches('header-drawer details, menu-drawer details')) return;
    if (details.open && root.classList.contains('is-from-header')) closePanel();
  }, true);

  document.addEventListener('focusin', function (event) {
    if (!root.classList.contains('is-from-header')) return;
    if (event.target.closest && event.target.closest('.ri-header-search')) closePanel();
  });

  function openFromHeader() {
    closeMenuForCart();
    var current = ++token;
    if (goalEl) goalEl.hidden = true;
    if (extrasEl) extrasEl.hidden = true;
    root.classList.add('is-from-header');
    document.documentElement.classList.add('ri-cart-open');
    openShell();
    /* No focus jump to the panel's own X: the header X is the close control here. */
    var icon = document.getElementById('cart-icon-bubble');
    if (icon) icon.focus({ preventScroll: true });
    fetch(cartUrl('get'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (current !== token) return;
        paintSummary(cart);
        return loadGoal(cart);
      })
      .catch(function () {
        if (current === token) paintGoal(0);
      });
  }

  document.addEventListener('click', function (event) {
    var icon = event.target.closest && event.target.closest('#cart-icon-bubble');
    if (!icon || !cartSheetWidth.matches) return;
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    if (root.classList.contains('is-open')) closePanel();
    else openFromHeader();
  });

  itemsEl.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ri-qty]');
    if (!button || button.disabled) return;
    var next = Number(button.getAttribute('data-ri-qty-set'));
    if (!isFinite(next) || next < 0) return;
    button.disabled = true;
    postCart('change', { id: button.getAttribute('data-ri-qty'), quantity: next })
      .then(function (cart) {
        if (isCart(cart)) {
          applyCart(cart);
          return;
        }
        /* No more in stock: keep the cart as it really is and say why the number did not go up. */
        showStockNote('That is all we have in stock.');
        return fetch(cartUrl('get'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(applyCart);
      })
      .catch(function () { button.disabled = false; });
  });

  var noteSave = root.querySelector('[data-ri-note-save]');
  if (noteSave && noteEl) {
    noteSave.addEventListener('click', function () {
      postCart('update', { note: noteEl.value || '' }).then(function (cart) {
        applyCart(cart);
        closeSheets();
      });
    });
  }

  /* Phone: a system add-on never opens Your Cart, so the header cart icon nudges and flashes yellow for it instead. */
  var phone = window.matchMedia('(max-width: 749px)');
  var pulseTimer = null;

  function pulseHeaderCart() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    icon.classList.remove('ri-cart-attention');
    void icon.offsetWidth;
    icon.classList.add('ri-cart-attention');
    clearTimeout(pulseTimer);
    pulseTimer = setTimeout(function () {
      icon.classList.remove('ri-cart-attention');
    }, 2200);
  }

  window.RICartPulse = pulseHeaderCart;

  function onCartUpdate(event) {
    var page = document.getElementById('MainContent');
    if (!page || page.getAttribute('data-template') !== 'product') return;
    /* A system add-on never opens Your Cart. On a phone the header cart flashes for it. */
    if (event && event.source === 'ri-system-addon') {
      if (phone.matches) pulseHeaderCart();
      return;
    }
    if (!event || event.source !== 'product-form' || !event.cartData) return;
    var data = event.cartData;
    if (data.items || data.status) return;
    if (!data.product_title && !data.title) return;
    /* Every width opens Your Cart after an add on the product page (owner, 2026-10-23; phones only flashed the header cart before). */
    showLine(data);
  }

  function boot() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', fitSheet);
    window.visualViewport.addEventListener('scroll', fitSheet);
  }
  desktop.addEventListener('change', function () {
    if (desktop.matches && root.classList.contains('is-open')) closePanel();
    else fitSheet();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !root.classList.contains('is-open') || desktop.matches) return;
    closePanel();
  });

  /* Back from checkout (owner, 2026-10-23): an iPhone brings the page back as it was left, with Your Cart open.
     ri-scroll-lock.js hides the sheet, but the header kept its X and this script still thought the page was locked.
     Close it the whole way: header cart icon back, lock flag cleared. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) closePanel();
  });
})();
